/** The texts of the page lock flows (OrbitalPlan/18 D8), shared by the lock drawer and the lock panel. */

export const LockNote =
    "Locking hides a page and its children from everyone except the lock's readers, space Owners and platform admins.";

export const LockWarning =
    "Until Ark manages readers itself, you are not added as a reader automatically: unless you are a space Owner or a platform admin, " +
    "the page disappears for you until an Identity admin adds you as Lock Reader or Lock Owner in Identity Web.";

export const CannotLock =
    "You cannot lock pages in this space: locking needs the Ark Contributor or Ark Owner role on the space.";

export const CannotUnlock = "Only the lock's owners, space Owners and platform admins can unlock this page.";
